import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface FeaturedGuideProps {
  guide: {
    id: string;
    title: string;
    description: string;
    category: string;
    image: string;
    alt: string;
    readTime: string;
    author: {
      name: string;
      credentials: string;
    };
  };
}

const FeaturedGuide = ({ guide }: FeaturedGuideProps) => {
  return (
    <div className="relative bg-gradient-to-r from-primary to-secondary rounded-2xl overflow-hidden shadow-elevated">
      <div className="grid lg:grid-cols-2 gap-8">
        <div className="p-8 lg:p-12 flex flex-col justify-center">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4 w-fit">
            <Icon name="SparklesIcon" size={20} variant="solid" className="text-white" />
            <span className="text-white font-semibold text-sm">Featured Guide</span>
          </div>

          <h2 className="text-3xl lg:text-4xl font-headline font-bold text-white mb-4">
            {guide.title}
          </h2>

          <p className="text-white/90 text-lg mb-6 line-clamp-3">
            {guide.description}
          </p>

          <div className="flex items-center space-x-6 mb-6 text-white/80">
            <div className="flex items-center space-x-2">
              <Icon name="ClockIcon" size={18} variant="outline" />
              <span className="text-sm">{guide.readTime}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="UserIcon" size={18} variant="outline" />
              <span className="text-sm">{guide.author.name}, {guide.author.credentials}</span>
            </div>
          </div>

          <Link
            href={`/care-guides-hub/${guide.id}`}
            className="inline-flex items-center justify-center space-x-2 px-8 py-3 bg-white text-primary rounded-lg hover:shadow-elevated hover:-translate-y-0.5 transition-all duration-300 font-semibold w-fit"
          >
            <span>Read Featured Guide</span>
            <Icon name="ArrowRightIcon" size={20} variant="outline" />
          </Link>
        </div>

        <div className="relative h-64 lg:h-auto">
          <AppImage
            src={guide.image}
            alt={guide.alt}
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default FeaturedGuide;